import { Component } from '@angular/core';

@Component({
  selector: 'app-badge-showcase',
  templateUrl: './badge-showcase.component.html',
  styleUrls: ['./badge-showcase.component.scss']
})
export class BadgeShowcaseComponent {
  closedBadges = new Set<string>();

  variants = ['primary', 'secondary', 'success', 'warning', 'error', 'info'];
  sizes = ['small', 'medium', 'large'];

  notificationCount: number = 5;
  warningCount: number = 3;
  errorCount: number = 0;
  messageCount: number = 125;

  onCloseBadge(badgeId: string): void {
    this.closedBadges.add(badgeId);
  }

  isBadgeClosed(badgeId: string): boolean {
    return this.closedBadges.has(badgeId);
  }

  resetClosedBadges(): void {
    this.closedBadges.clear();
  }
}
